import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'

export const UserRequisition = () => {
  return (
    <>
        <RoutingMenu activeScreen="userRequisition" />
            <div className=''>
                {/* <iframe
                    src={`${config.RootUrl}/faculty/library/Requisition/Requisition.php?isIframe=true`}
                    className="iframe col-md-12" >
                </iframe> */}

                {
                  config.account == "faculty" ?
                    <iframe
                      src={`${config.RootUrl}/faculty/library/Requisition/Requisition.php?isIframe=true`}
                      className="iframe col-md-12" >
                    </iframe>
                    :
                    <iframe
                      src={`${config.RootUrl}/student/library/view/requisition/requisition.php?isIframe=true`}
                      className="iframe col-md-12" >
                    </iframe>
                }
                
            </div>
    </>
  )
}
